import React, { useEffect, useState } from 'react';
import '../Login/login.css';
import axios from "axios";
import BaseUrl from '../../base-api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const Register = () => {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false); 
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [error, setError] = useState(''); 
  const [timer, setTimer] = useState(0);
  const [formType, setFormType] = useState(() => {
    return sessionStorage.getItem('formType') || 'CAPF';
  });
const navigate= useNavigate();

useEffect(() => {
  let interval;
  if (timer > 0) {
    interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  }
  return () => clearInterval(interval);
}, [timer]);

  const handleMobile = (e) => {
    const value = e.target.value;
    let number = value.replace(/\D/g, ''); 
    if (number.length > 10) {
      number = number.slice(0, 10); 
    }
    setError(''); 
   
    setMobile(number) 
  };
  

  const handleOtp = (e) => {

    const value = e.target.value;
    let number = value.replace(/\D/g, ''); 
    if (number.length > 6) {
      number = number.slice(0, 6); 
    }
    setError(''); 
    setOtp(number);
  };

  const sendOtp = async() => {
   
    let number = mobile;
    if (!/^[6-9][0-9]*$/.test(number)) {
      setError('Number must start with a digit between 6 and 9, followed by any digits 0-9.');
     
    } else if (number.length < 10) {
      setError('Number must be exactly 10 digits long.');
     
    } else {
      setError(''); 

      setIsSendingOtp(true);
    try {
      const formData= {
        mobileNo:mobile,
        formType:formType
      }
    const res= await axios.post(`${BaseUrl}/api/auth/register-otp`,formData,{
      headers:{
      'Content-Type':"application/json"
      },

     
    });
    if(res.data?.status==200){
      toast.success(res.data.message);
      setIsOtpSent(true);
      setTimer(120);
      setOtp("")
    }
    else {
      toast.error(res.data?.message);
    }
  } catch (error) {
     toast.error(error.response?.data?.message);
  }
  finally{
    setIsSendingOtp(false);
  }
}
  };

  const handleSubmit= async(e)=>{
    e.preventDefault();
    try {
        // dispatch(setLoading(true));
        const formData= {
          mobileNo:mobile,
          otp:otp
        }
      const res= await axios.post(`${BaseUrl}/api/auth/verify_otp`,formData,{
        headers:{
        'Content-Type':"application/json"
        },
   
      });
       if (res.data.status === 200) {
    sessionStorage.setItem("userToken", res.data.data);
    sessionStorage.setItem("$details", JSON.stringify(res.data));
    const role = String(res.data.role || "").trim().toUpperCase();
    switch (role) {
        case "USER":
            navigate("/dashboard/capf-registration", { replace: true });
            break;
        case "ADMIN":
            navigate("/dashboard/home", { replace: true });
            break;
        case "DISTRICT_ADMIN":
            navigate("/dashboard/home", { replace: true });
            break;
        case "HQ_ADMIN":
            navigate("/dashboard/hq/home", { replace: true });
            break;
        default:
            console.warn("Unknown role:", res.data.role);
            navigate("/login", { replace: true }); 
    }
}

      else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
       toast.error(error.response.data.message);
    }
    finally{
      // dispatch(setLoading(false));
    }
  }


  return (
    <div className='loginDiv'>
      <div className="login-container" style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '8px' }}>
        <h2 style={{ color: 'grey' }}>{formType} Registration</h2>
        <form onSubmit={handleSubmit}>
          
          {error && (
            <div className="error" style={{ color: 'red', marginBottom: '10px' }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label>Mobile Number:</label>
            <input
              type="text"
              value={mobile}
              onChange={handleMobile}
              placeholder='Enter Registered Number'
              disabled={isOtpSent}
              required
            />
          </div>

          {isOtpSent && (
            <div className="form-group">
              <label>OTP:</label>
              <input
                type="text"
                value={otp}
                onChange={handleOtp}
                placeholder='Enter OTP'
                required
              />
            </div>
          )}

          {!isOtpSent && (
            <button type="button" onClick={sendOtp} disabled={isSendingOtp}>{isSendingOtp ? "Sending..." : "Send OTP"}</button>
          )}

          {isOtpSent && (
            <>
            <div className='d-flex'>
            <button className='me-2' type="submit">Login</button>
           <button className='btn btn-danger' type="button" onClick={sendOtp} disabled={timer > 0}>
                {timer > 0 ? `Resend OTP (${timer}s)` : "Resend OTP"}
              </button>
            </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default Register;
